import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const ADVANCED_SETTINGS = 'Advanced Settings'
export const DEFAULT_SWITCH = 'default switch'

export default {
  [PORTUGUESE]: {
    [ADVANCED_SETTINGS]: 'Configurações Avançadas',
    [DEFAULT_SWITCH]: 'não é um tipo válido',
  },

  [ENGLISH]: {
    [ADVANCED_SETTINGS]: 'Advanced Settings',
    [DEFAULT_SWITCH]: 'is not a valid type',
  },

  [SPANISH]: {
    [ADVANCED_SETTINGS]: 'Ajustes Avanzados',
    [DEFAULT_SWITCH]: 'no es un tipo valido',
  },
}
